'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _pagination = require('../pagination');

var _pagination2 = _interopRequireDefault(_pagination);

var _dyzioSearchBox = require('../dyzio-search-box');

var _dyzioSearchBox2 = _interopRequireDefault(_dyzioSearchBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstagramStoryMenu = function InstagramStoryMenu(props) {
  var onPageIncrement = props.onPageIncrement,
      onPageDecrement = props.onPageDecrement,
      currentPage = props.currentPage,
      totalPages = props.totalPages,
      onSearch = props.onSearch,
      isLoading = props.isLoading;

  return _react2.default.createElement(
    _semanticUiReact.Segment,
    null,
    _react2.default.createElement(
      _semanticUiReact.Grid,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: '12' },
        _react2.default.createElement(_dyzioSearchBox2.default, {
          onSearch: onSearch,
          placeholderText: 'Search captions...',
          isLoading: isLoading
        })
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: '4' },
        _react2.default.createElement(_pagination2.default, {
          onPageIncrement: onPageIncrement,
          onPageDecrement: onPageDecrement,
          currentPage: currentPage,
          totalPages: totalPages
        })
      )
    )
  );
};

InstagramStoryMenu.propTypes = {
  onPageIncrement: _propTypes2.default.func.isRequired,
  onPageDecrement: _propTypes2.default.func.isRequired,
  onSearch: _propTypes2.default.func.isRequired,
  currentPage: _propTypes2.default.number.isRequired,
  totalPages: _propTypes2.default.number.isRequired,
  isLoading: _propTypes2.default.bool
};
InstagramStoryMenu.defaultProps = {
  isLoading: false
};

exports.default = InstagramStoryMenu;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/instagram-story-menu/index.js
 ** module id = 2594
 ** module chunks = 0
 **/